import React from 'react';
import PropTypes from 'prop-types';
import { IMPORT_MODAL_PREFIX as PREFIX } from './consts';
import css from './ImportModal.css';

const FormatTable = ({ formatRows, translate }) => (
    <table className={css.formatTable}>
        <tbody>
            <tr>
                <th>{translate(`${PREFIX}.COLUMN`)}</th>
                <th />
                <th>{translate(`${PREFIX}.EXAMPLE`)}</th>
            </tr>
            {formatRows.map(row => (
                <tr key={row.column}>
                    <td className={css.colName}>{row.column}</td>
                    <td>
                        <span className={row.required ? css.badgeRequired : css.badgeOptional}>
                            {translate(`${PREFIX}.${row.required ? 'REQUIRED' : 'OPTIONAL'}`)}
                        </span>
                    </td>
                    <td className={css.colExample}>{row.example}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

FormatTable.propTypes = {
    formatRows: PropTypes.arrayOf(PropTypes.object).isRequired,
    translate: PropTypes.func.isRequired,
};

export default FormatTable;
